import { ProtocoloAtendimentoTipo } from './protocolo-atendimento-tipo.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class ProtocoloAtendimentoTipoService {

    constructor(private http: Http){
    }

    getProtocoloAtendimentoTipos(): Observable<ProtocoloAtendimentoTipo[]> {
        return this.http.get(`${NTECH_API}/protocolo-atendimento-tipo`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/protocolo-atendimento-tipo/protocolo-atendimento-tipo.service.ts